/**
 * Reductor de REDUX para controlar los estados de la papelera (trash)
 */

import { TRASH } from '../../application/types';
import { Map } from 'immutable';

export const trash = ( state = Map({ type: TRASH.READ.READ_TRASH }), action ) => {

  switch ( action.type ) {

    case TRASH.READ.READ_TRASH:
      return state.set('read', { type: action.type });

    case TRASH.READ.READING_TRASH:
      return state.set('read', { type: action.type });

    case TRASH.READ.READED_TRASH:
      return state.set('read', {
        type: action.type,
        items: action.items
      });

    case TRASH.READ.ERROR:
      return state.set('read', {
        type: action.type,
        code: action.code,
        message: action.message
      });

    case TRASH.RESTORE.RESTORING_TRASH:
      return state.set('restore', { type: action.type });

    case TRASH.RESTORE.RESTORED_TRASH:
      return state.set('restore', {
        type: action.type,
        id: action.id
      });

    case TRASH.RESTORE.ERROR:
      return state.set('restore', {
        type: action.type,
        code: action.code,
        message: action.message
      });

    case TRASH.PURGE.PURGING_TRASH:
      return state.set('purge', { type: action.type });

    case TRASH.PURGE.PURGED_TRASH:
      return state.set('purge', {
        type: action.type,
        id: action.id
      });

    case TRASH.PURGE.ERROR:
      return state.set('purge', {
        type: action.type,
        code: action.code,
        message: action.message
      });

    case TRASH.PURGE_ALL.PURGING_ALL_TRASH:
      return state.set('purgeAll', { type: action.type });

    case TRASH.PURGE_ALL.PURGED_ALL_TRASH:
      return state.set('purgeAll', {
        type: action.type,
        count: action.count
      });

    case TRASH.PURGE_ALL.ERROR:
      return state.set('purgeAll', {
        type: action.type,
        code: action.code,
        message: action.message
      });

    default:
      return state;
  }

}
